import { render, staticRenderFns } from "./ReportResultsTable.vue?vue&type=template&id=98bbaaca&scoped=true"
import script from "./ReportResultsTable.vue?vue&type=script&lang=js"
export * from "./ReportResultsTable.vue?vue&type=script&lang=js"
import style0 from "./ReportResultsTable.vue?vue&type=style&index=0&id=98bbaaca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bbaaca",
  null
  
)

export default component.exports